import { initPipelinesIndex } from '~/ci/pipeline_details/pipelines_index';

initPipelinesIndex();
